import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { server } from "./configs";
import Axios from "axios";
import Swal from "sweetalert2";
import Loading from "./components/Loading";
import NoSetInfo from "./screens/NoSetInfo";
import NoToken from "./NoToken";

function Auth({ match }) {
  const [status, setStatus] = useState(0);
  const [token, setToken] = useState(match.params.tokenCode);

  const code = match.params.urlcode;
  const destName = match.params.destName;

  useEffect(() => {
    if (match.url !== "/no-info") {
      Axios.post(`${server}/public/users/me?param=${code}`)
        .then(({ data, status }) => {
          localStorage.clear();

          if (data.authentication)
            localStorage.setItem("jwt", data.authentication);
          if (data.token) localStorage.setItem("token", data.token);

          setToken(data.token);
          setStatus(status);
        })
        .catch((e) => {
          console.log(e);
          setStatus(e.response.status);
        });
    }
  }, [code, match.url]);

  if (status === 200) {
    return (
      <Redirect
        to={"/token/" + token + (destName ? "/" + destName : "/greeting")}
        path="*"
      />
    );
  } else if (status === 0) {
    if (match.url === "/no-info") {
      return <NoSetInfo />;
    } else {
      return <Loading />;
    }
  } else if (status === 412) {
    return <NoSetInfo />;
  } else {
    let errorMsg = "";
    if (status === 400) {
      errorMsg = "잘못된 URL입니다. 주소를 확인해 주세요.";
    } else if (status === 403) {
      errorMsg = "인원이 초과되어 조사가 마감되었습니다. 감사합니다.";
    } else if (status === 404) {
      errorMsg = "잘못된 URL입니다. 관리자에게 연락 부탁드립니다.";
    } else if (status === 500) {
      errorMsg = "서버 문제가 발생했습니다. 관리자에게 연락 부탁드립니다.";
    }
    Swal.fire({
      title: "",
      confirmButtonText: "닫기",
      confirmButtonColor: "#00aeef",
      text: errorMsg,
      heightAuto: false,
    });
    return <NoToken />;
  }
}

export default Auth;
